module.exports = __webpack_public_path__ + "static/media/tile-price-6.3f706d48.jpg";